import { ALL_WHITE_LINES } from "../utils";

const curatedStories = [
  {
    label: "Select a Case Study",
    filters: {}, // no mutation on filters
  },
  {
    label: "Hacking: Carmen Aristegui",
    notes:
      "The digital targeting of Carmen Aristegui extends later to include her colleagues and son, one month after their major exposure of corruption by the Mexican President.",
    filters: {
      FIELD_OF_OPERATION: {
        selected: ["Mexico"],
      },
      TARGETS: {
        selected: [
          "Daniel Lizárraga",
          "Salvador Camarena",
          "Rafael Cabrera",
          "Sebastián Barragán",
          "Carmen Aristegui",
          "Emilio Aristegui",
        ],
      },
      EVENT_TYPE: {
        selected: [
          "Zero-Click Exploits",
          "Zero Click:targeted",
          "One-Click Exploits",
          "One Click:targeted",
          "Infection",
          "Zero Click:contextual",
          "One Click:contextual",
          "Related",
          ...ALL_WHITE_LINES,
        ],
      },
    },
  },
  {
    label: "Hacking: Nihalsing Rathod",
    notes:
      "Digital targeting of Indian human rights lawyers Nihalsing Rathod extends to include Shalini Gera and Surendra Gadling, and their associate and client Anand Teltumbde, a Dalit-rights scholar and activist, within the same few months.",
    filters: {
      FIELD_OF_OPERATION: {
        selected: ["India"],
      },
      TARGETS: {
        selected: [
          "Surendra Gadling",
          "Shalini Gera",
          "Nihalsing Rathod",
          "Anand Teltumbde",
        ],
      },
      EVENT_TYPE: {
        selected: [
          "Zero-Click Exploits",
          "Zero Click:targeted",
          "One-Click Exploits",
          "One Click:targeted",
          "Infection",
          "Zero Click:contextual",
          "One Click:contextual",
          "Related",
          ...ALL_WHITE_LINES,
        ],
      },
    },
  },
  {
    label: "Intimidation: Maati Monjib",
    notes:
      "Maati Monjib’s digital targeting in Morocco (in blue) interlaced with constant forms of physical violence and psychological intimidation, including against his family and colleagues (in red).",
    filters: {
      FIELD_OF_OPERATION: {
        selected: ["Morocco"],
      },
      TARGETS: {
        selected: ["Maati Monjib"],
      },
      EVENT_TYPE: {
        selected: [
          "Zero-Click Exploits",
          "Zero Click:targeted",
          "One-Click Exploits",
          "One Click:targeted",
          "Infection",
          "Zero Click:contextual",
          "One Click:contextual",
          "Murder",
          "Assault",
          "Intimidation",
          "Violence",
          "Related",
          ...ALL_WHITE_LINES,
        ],
      },
    },
  },
  {
    label: "Intimidation: Carmen Aristegui",
    notes:
      "Carmen Aristegui’s digital targeting (in blue) in Mexico entangled with break-ins to the offices of Aristegui Noticias, intimidation, lawsuits and smear campaigns (in red).",
    filters: {
      FIELD_OF_OPERATION: {
        selected: ["Mexico"],
      },
      TARGETS: {
        selected: [
          "Daniel Lizárraga",
          "Salvador Camarena",
          "Rafael Cabrera",
          "Sebastián Barragán",
          "Carmen Aristegui",
          "Emilio Aristegui",
        ],
      },
      EVENT_TYPE: {
        selected: [
          "Zero-Click Exploits",
          "Zero Click:targeted",
          "One-Click Exploits",
          "One Click:targeted",
          "Infection",
          "Zero Click:contextual",
          "One Click:contextual",
          "Murder",
          "Assault",
          "Intimidation",
          "Violence",
          "Related",
          ...ALL_WHITE_LINES,
        ],
      },
    },
  },
  {
    label: "Omar Abdulaziz",
    notes:
      "<div>Digital targeting extends the reach of state power to include human rights dissenters in exile, while also physically targeting their colleagues and families in their home country.</div><br /><div>Omar Abdulaziz is targeted using Pegasus while in exile in Montreal, after which two of his brothers are arrested in Saudi Arabia.</div>",
    filters: {
      TARGETS: {
        selected: ["Omar Abdulaziz"],
      },
      EVENT_TYPE: {
        selected: [
          "Zero-Click Exploits",
          "Zero Click:targeted",
          "One-Click Exploits",
          "One Click:targeted",
          "Infection",
          "Zero Click:contextual",
          "One Click:contextual",
          "Murder",
          "Assault",
          "Intimidation",
          "Violence",
          "Related",
          ...ALL_WHITE_LINES,
        ],
      },
    },
  },
  {
    label: "Rwandan Opposition Activists",
    notes:
      "All Rwandan opposition activists were living abroad when targeted by Pegasus in 2019, with Faustin Rukundo’s wife having earlier been arrested by Rwandan authorities and held incommunicado.",
    filters: {
      TARGETS: {
        selected: [
          "Sulah Nuwamanya",
          "Placide Kayumba",
          "Frank Ntwali",
          "Faustin Rukundo",
          "David Batenga",
        ],
      },
      EVENT_TYPE: {
        selected: [
          "Zero-Click Exploits",
          "Zero Click:targeted",
          "One-Click Exploits",
          "One Click:targeted",
          "Infection",
          "Zero Click:contextual",
          "One Click:contextual",
          "Murder",
          "Assault",
          "Intimidation",
          "Violence",
          "Related",
          ...ALL_WHITE_LINES,
        ],
      },
    },
  },
  {
    label: "Pegasus—Saudi Arabia",
    notes:
      "<div>Saudi Arabia’s purchase of Pegasus in 2017 was reportedly enabled by another of NSO’s affiliate companies—Q Cyber Technologies SARL, based in Luxembourg—after which a purge within Saudi was supplemented with a digital spying campaign in 2018 targeting Saudi dissenters abroad.</div><br /> <div>Analysis of corporate documents provided by Amnesty in this project suggest that Saudi purchases of Pegasus licenses may have been what contributed to Q Cyber's jump in profits from $24,738,462 in 2016 to $169,214,909 in 2019.</div>",
    filters: {
      FIELD_OF_OPERATION: {
        selected: ["Saudi Arabia"],
      },
      EVENT_TYPE: {
        selected: [
          "Zero-Click Exploits",
          "Zero Click:targeted",
          "One-Click Exploits",
          "One Click:targeted",
          "Infection",
          "Zero Click:contextual",
          "One Click:contextual",
          "Murder",
          "Assault",
          "Intimidation",
          "Violence",
          "Related",
          "Corporate",
          "Corporate Event",
        ],
      },
    },
  },

  {
    label: "Pegasus—UAE",
    notes:
      "<div>Leaked documents reveal that NSO Group’s affiliate Circles Solutions reportedly enabled the sale of malware to the United Arab Emirates in 2016, with whom Israel had no official connections at the time.</div><br /><div>Since this reported purchase, the UAE has hacked the devices of dozens of human rights defenders and reportedly developed its own cyberweapons in close collaboration with the Israeli cybersecurity industry.</div>",
    filters: {
      FIELD_OF_OPERATION: {
        selected: ["UAE"],
      },
      EVENT_TYPE: {
        selected: [
          "Zero-Click Exploits",
          "Zero Click:targeted",
          "One-Click Exploits",
          "One Click:targeted",
          "Infection",
          "Zero Click:contextual",
          "One Click:contextual",
          "Murder",
          "Assault",
          "Intimidation",
          "Violence",
          "Related",
          "Corporate",
          "Corporate Event",
        ],
      },
    },
  },
];

export default curatedStories;
